/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelExecutionDto
 */
export interface CancelExecutionDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CancelExecutionDto
     */
    executionIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CancelExecutionDto
     */
    dryRun?: boolean;
}

/**
 * Check if a given object implements the CancelExecutionDto interface.
 */
export function instanceOfCancelExecutionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "executionIds" in value;

    return isInstance;
}

export function CancelExecutionDtoFromJSON(json: any): CancelExecutionDto {
    return CancelExecutionDtoFromJSONTyped(json, false);
}

export function CancelExecutionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelExecutionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'executionIds': json['executionIds'],
        'dryRun': !exists(json, 'dryRun') ? undefined : json['dryRun'],
    };
}

export function CancelExecutionDtoToJSON(value?: CancelExecutionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'executionIds': value.executionIds,
        'dryRun': value.dryRun,
    };
}

